import dynamic from "next/dynamic";

export const DynamicContentBookmark = dynamic(() =>
  import("scmp-app/components/content/content-bookmark").then(module => module.ContentBookmark),
);
